class Playlist {
    constructor(props) {
        this.name = props.name;
        this.tracks = props.tracks;
        this.active = props.active;
    }
}

module.exports = Playlist;
